export const ACCOUNTSANDLOANS = {
  ACCOUNT_TYPE:
  {
    POST_SWIFT: 'postaccountbalance',
    PRE_SWIFT: 'preaccountbalance',
  },
  ATOPAYMENTFORM:
  {
    TO_ACCOUNT_NAME: 'AUSTRALIAN TAXATION OFFICE',
    TO_ACCOUNT_NO: '093003 -- 316385',
    BANK_BSB: '093003',
    BANK_ACCOUNT_NO: '316385',
    BANK_NAME: 'Reserve Bank of Australia',
    BANK_ADDRESS: 'Martin Place',
    BANK_CITY: 'Sydney',
    BANK_STATE: 'NSW',
    BANK_COUNTRY: 'AUS',
    BANK_ZIP: '2000',
  },
  PRE_SWIFT_TRX_REPORT_URL: '/ReportServer/Pages/ReportViewer.aspx?%2fEPIC%2fPreSwiftPartnerAccountsandBalances&rs:Command=Render&rs:Embed=True',
  POST_SWIFT_TRX_REPORT_URL: '/ReportServer/Pages/ReportViewer.aspx?%2fEPIC%2fPostSwiftPartnerAccountsandBalances&rs:Command=Render&rs:Embed=True',
  PRODUCT_TYPE:
  {
    SHORT_TERM_LOAN: 'STL',
    PARTNER_PERSONAL_LOAN: 'PPL',
    PARTNER_CAPITAL_LOANS: 'PCL',
    SHORT_TERM_LOAN_LABEL: 'Short term loan',
    PARTNER_PERSONAL_LOAN_LABEL: 'Partner personal loans',
    PARTNER_CAPITAL_LOANS_LABEL: 'Partner capital loans',
    LOCKED_ACCOUNT_LABEL: 'Locked accounts',
  },
  TRANSACTION_INFO:
  {
    LABEL1: 'Your online STA details do not consitute your official statement.',
    LABEL2: 'For discrepancy queries or final statement details please contact National Partner Services at partnerservices@deloitte.com.au.',
  },
  TRANSFER_TYPE:
  {
    ATO: 'ATO - Payments',
    BANK: 'Bank Account',
    CHEQUE: 'Cheque',
    INTERNAL: 'Internal DTT Account',
    OVERSEAS: 'Overseas Bank Account',
  },
  FILTER_TYPE:
  {
    ACTIVE: 'active',
    EXTINGUISHED: 'extinguished',
  },
}

export const BANKTRANSFER_LIST_OPTIONS = {
  TRANSFERS: [
    { value: ACCOUNTSANDLOANS.TRANSFER_TYPE.ATO, label: ACCOUNTSANDLOANS.TRANSFER_TYPE.ATO },
    { value: ACCOUNTSANDLOANS.TRANSFER_TYPE.BANK, label: ACCOUNTSANDLOANS.TRANSFER_TYPE.BANK },
    { value: ACCOUNTSANDLOANS.TRANSFER_TYPE.CHEQUE, label: ACCOUNTSANDLOANS.TRANSFER_TYPE.CHEQUE },
    { value: ACCOUNTSANDLOANS.TRANSFER_TYPE.INTERNAL, label: ACCOUNTSANDLOANS.TRANSFER_TYPE.INTERNAL },
    { value: ACCOUNTSANDLOANS.TRANSFER_TYPE.OVERSEAS, label: ACCOUNTSANDLOANS.TRANSFER_TYPE.OVERSEAS },
  ],
}



// WEBPACK FOOTER //
// ./src/constants/accountsandloans.js